/* FAQ accordion, ported from About.dc.html (2026-08-10 handoff).
   One panel open at a time; clicking the open one closes it. */
(function () {
  var list = document.querySelector('[data-mpa-faq]');
  if (!list) return;
  var items = Array.prototype.slice.call(list.querySelectorAll('.mpa-faq__item'));

  function setOpen(item, open) {
    var btn = item.querySelector('.mpa-faq__q');
    var panel = item.querySelector('.mpa-faq__a');
    var mark = item.querySelector('.mpa-faq__mark');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    mark.textContent = open ? '−' : '+';
  }

  items.forEach(function (item) {
    item.querySelector('.mpa-faq__q').addEventListener('click', function () {
      var isOpen = !item.querySelector('.mpa-faq__a').hidden;
      items.forEach(function (other) { setOpen(other, false); });
      if (!isOpen) setOpen(item, true);
    });
  });
})();
